import { gql } from '@apollo/client'

export const GET_CAMPAIGN_AI_SUGGESTIONS = gql`
    query GET_CAMPAIGN_AI_SUGGESTIONS($campaignId: ID!) {
        campaigns(where: { id: $campaignId }) {
            id
            headers
            subheaders
            descriptions
        }
    }
`

export const GET_MEDIA_BUYING_CONNECTED_DATA = gql`
    query GET_MEDIA_BUYING_CONNECTED_DATA($campaignId: ID!) {
        publisherUserAdAccounts(campaignId: $campaignId) {
            publisher_id
            campaign_id
            user_id
            type
            label
            ad_account
            ad_account_name
            currency
            min_daily_budget
            page_id
            instagram_id
            business_id
            pixel
            pixel_name
            pixel_active
            tos_accepted
            timezone
            timezone_offset
            status
            created_at
            updated_at
        }
    }
`

export const GET_USERS_AD_ACCOUNTS = gql`
    query GetUserAdAccounts($campaignId: ID!) {
        getUserAdAccounts(campaignId: $campaignId) {
            id
            name
            account
            businessId
            pixels {
                id
                name
            }
            pages {
                id
                name
                global_brand_page_name
            }
            instagram_accounts {
                id
                username
                name
                profile_picture_url
                followers_count
            }
        }
    }
`

export const GET_AD_INSIGHTS = gql`
    query PublisherAdAccountInsight($publisherAdAccountInsightInput: PublisherAdAccountInsightInput) {
        publisherAdAccountInsight(publisherAdAccountInsightInput: $publisherAdAccountInsightInput) {
            publisher_id
            campaign_id
            data {
                ad_account
                insight_name
                value
            }
        }
    }
`

export const MEDIA_BUYER_AD_ACCOUNT_REFRESH = gql`
    query MEDIA_BUYER_AD_ACCOUNT_REFRESH(
        $campaignId: ID
        $publisherId: ID
        $returnTokenErrors: Boolean
        $cache: Boolean
    ) {
        getUserAdAccounts(
            campaignId: $campaignId
            publisherId: $publisherId
            returnTokenErrors: $returnTokenErrors
            cache: $cache
        ) {
            id
            name
            ad_accounts {
                id
                name
                account
                businessId
                time_zone_offset
                time_zone_name
                tos_accepted
                amount_spent
                month_spend
                currency
                usable
                unusable_reason
                pixels {
                    id
                    name
                }
                pages {
                    id
                    name
                    global_brand_page_name
                    usable
                    unusable_reason
                }
                instagram_accounts {
                    id
                    username
                    name
                    profile_picture_url
                    followers_count
                }
            }
        }
    }
`

export const GET_MEDIA_BUYER_INITIAL = gql`
    query GET_MEDIA_BUYER_INITIAL($where: CampaignWhere, $campaignId: ID!) {
        getUserAdAccounts(campaignId: $campaignId) {
            id
            name
            ad_accounts {
                id
                name
                account
                businessId
                time_zone_offset
                time_zone_name
                tos_accepted
                amount_spent
                month_spend
                currency
                usable
                unusable_reason
                pixels {
                    id
                    name
                }
                pages {
                    id
                    name
                    global_brand_page_name
                    usable
                    unusable_reason
                }
                instagram_accounts {
                    id
                    username
                    name
                    profile_picture_url
                    followers_count
                }
            }
        }
        publisherUserAdAccounts(campaignId: $campaignId) {
            publisher_id
            campaign_id
            user_id
            type
            label
            ad_account
            ad_account_name
            min_daily_budget
            currency
            page_id
            instagram_id
            business_id
            pixel
            pixel_name
            tos_accepted
            timezone
            timezone_offset
            status
            created_at
            updated_at
        }
        campaigns(where: $where) {
            id
            name
            userStatus
            systemStatus
            isMediaBuyingLive
            isMediaBuyingReady
        }
        getPublishersFromPostgres {
            id
            name
            status
            authorize_url
            client_id
            scope
        }
    }
`
export const DISCONNECT_PUBLISHER_CAMPAIGN = gql`
    mutation Mutation($disconnectPublisher: DisconnectPublisherInput) {
        disconnectPublisher(disconnectPublisher: $disconnectPublisher) {
            campaign_id
            publisher_id
            type
            label
            ad_account
            ad_account_name
            page_id
            business_id
            pixel
            pixel_name
            tos_accepted
            status
            created_at
            updated_at
        }
    }
`

export const UPDATE_PUBLISHER_CAMPAIGN_SETTINGS = gql`
    mutation Mutation($publisherCampaignSettingsInput: PublisherCampaignSettingsInput) {
        updatePublisherCampaignSettings(publisherCampaignSettingsInput: $publisherCampaignSettingsInput) {
            campaign_id
            publisher_id
            type
            label
            ad_account
            ad_account_name
            page_id
            business_id
            pixel
            pixel_name
            tos_accepted
            special_ad_categories
            timezone_offset
            timezone
            status
            created_at
            updated_at
        }
    }
`

export const CONNECT_CAMPAIGN_TO_PUBLISHER = gql`
    mutation ConnectCampaignToPublisher($oAuthPublisherInput: OAuthPublisherInput) {
        connectCampaignToPublisher(oAuthPublisherInput: $oAuthPublisherInput) {
            type
            label
            ad_account
            ad_account_name
            page_id
            business_id
            pixel
            pixel_name
            tos_accepted
            status
        }
    }
`
export const GET_TOS_STATUS = gql`
    query Query($publisherId: ID!, $campaignId: ID!) {
        publisherTOSStatus(publisher_id: $publisherId, campaign_id: $campaignId)
    }
`

export const GET_PAGE_DESCRIPTION_DATA = gql`
    query Query($pageId: String!, $publisherId: String!, $campaignId: ID) {
        publisherPageData(page_id: $pageId, publisher_id: $publisherId, campaign_id: $campaignId)
    }
`
export const GET_PUBLISHER_LEAD_FORMS = gql`
    query GetPublisherLeadForms($publisher_id: ID!, $page_id: String!, $campaign_id: ID) {
        publisherPageLeadForms(publisher_id: $publisher_id, page_id: $page_id, campaign_id: $campaign_id) {
            id
            name
            status
            used
            created_time
            locale
            privacy_policy_url
            form_type
            follow_up_action_url
            questions {
                id
                key
                label
                type
                options {
                    key
                    value
                }
            }
            context_card {
                id
                title
                content
                style
            }
            is_optimized_for_quality
            question_page_custom_headline
            follow_up_action_text
            legal_content {
                id
                privacy_policy {
                    url
                    link_text
                }
            }
            thank_you_page {
                title
                body
                button_type
                button_text
                website_url
            }
        }
    }
`

export const ARCHIVE_LEAD_FORM = gql`
    mutation ArchiveLeadForm($publisherId: ID!, $formId: ID!, $pageId: String!, $campaignId: ID) {
        archiveLeadForm(publisher_id: $publisherId, form_id: $formId, page_id: $pageId, campaign_id: $campaignId)
    }
`

export const UNARCHIVE_LEAD_FORM = gql`
    mutation UnarchiveLeadForm($publisherId: ID!, $formId: ID!, $pageId: String!, $campaignId: ID) {
        unArchiveLeadForm(publisher_id: $publisherId, form_id: $formId, page_id: $pageId, campaign_id: $campaignId)
    }
`

export const CREATE_LEAD_FORM = gql`
    mutation CreateLeadForm($publisherId: ID!, $pageId: String!, $instantForm: JSON, $campaignId: ID) {
        createLeadForm(publisher_id: $publisherId, page_id: $pageId, instantForm: $instantForm, campaign_id: $campaignId) {
            id
            name
            status
            created_time
            privacy_policy_url
            questions {
                type
                label
                key
                options {
                    key
                    value
                }
            }
        }
    }
`

export const UPDATE_LEAD_FORM = gql`
    mutation UpdateLeadForm($publisherId: ID!, $formId: ID!, $pageId: String!, $instantForm: JSON, $campaignId: ID) {
        updateLeadForm(publisher_id: $publisherId, form_id: $formId, page_id: $pageId, instantForm: $instantForm, campaign_id: $campaignId) {
            id
            name
            status
            created_time
            locale
            privacy_policy_url
            form_type
            follow_up_action_url
            questions {
                id
                key
                label
                type
                options {
                    key
                    value
                }
            }
            context_card {
                id
                title
                content
                style
            }
            is_optimized_for_quality
            question_page_custom_headline
            follow_up_action_text
            legal_content {
                id
                privacy_policy {
                    url
                    link_text
                }
            }
            thank_you_page {
                headline
                description
                call_to_action {
                    type
                    link
                    link_caption
                }
            }
        }
    }
`

export const GET_PAGE_LEAD_FORM = gql`
    query GetPageLeadForm($publisherId: ID!, $formId: String!, $campaignId: ID) {
        getPageLeadForm(publisher_id: $publisherId, form_id: $formId, campaign_id: $campaignId) {
            id
            name
            status
            created_time
            privacy_policy_url
            questions {
                type
                label
                key
                options {
                    key
                    value
                }
            }
        }
    }
`

export const GET_PIXEL_VALIDATION_DATA = gql`
    query GetPixelValidationData($publisherId: ID!, $campaignId: ID!, $pixelId: String) {
        getPixelValidationData(publisher_id: $publisherId, campaign_id: $campaignId, pixel_id: $pixelId) {
            pixel_id
            name
            creation_time
            last_fired_time
            is_created_by_business
            has_data
            events {
                event
                count
                last_fired_time
            }
            total_events
            validation_status
        }
    }
`

export const REFRESH_PIXEL_STATUS = gql`
    mutation RefreshPixelStatus($publisher_id: ID!, $campaign_id: ID!) {
        refreshPixelStatus(publisher_id: $publisher_id, campaign_id: $campaign_id)
    }
`

export const SAVE_AD_CREATIVE = gql`
    mutation CreateAdCreative(
        $input: CreateAdCreativeInput!
        $creativeTempId: String
        $adAccountId: String!
        $mediaLibrarySource: String
        $campaignId: ID
    ) {
        createAdCreative(
            input: $input
            creativeTempId: $creativeTempId
            adAccountId: $adAccountId
            mediaLibrarySource: $mediaLibrarySource
            campaignId: $campaignId
        ) {
            id
        }
    }
`

export const CLONE_AD_CREATIVE = gql`
    mutation CloneAdCreative(
        $sourceCreativeId: ID!
        $input: CreateAdCreativeInput!
        $adAccountId: String!
        $creativeTempId: String
        $mediaLibrarySource: String
        $campaignId: ID
    ) {
        cloneAdCreative(
            sourceCreativeId: $sourceCreativeId
            input: $input
            adAccountId: $adAccountId
            creativeTempId: $creativeTempId
            mediaLibrarySource: $mediaLibrarySource
            campaignId: $campaignId
        ) {
            id
        }
    }
`

export const CREATE_AD_CAMPAIGN = gql`
    mutation CreateAdCampaign($publisherId: String!, $campaignId: String!, $data: CreateAdCampaignInput!) {
        createAdCampaign(publisherId: $publisherId, campaignId: $campaignId, data: $data) {
            id
            name
            status
        }
    }
`

export const GET_AD_CAMPAIGN_BY_ID = gql`
    query GetAdCampaignById($id: String) {
        AdCampaign {
            adCampaignById(id: $id) {
                id
                name
                campaign_id
                publisher_id
                objective
                location_targeting
                status
                budget_mode
                lead_source
            }
        }
    }
`

export const ADD_AUDIENCE_TO_AD_CAMPAIGN = gql`
    mutation AddAudienceToAdCampaign($publisherId: String!, $adCampaignId: String!, $data: CreateAdCampaignInput!) {
        addAudienceToAdCampaign(publisherId: $publisherId, adCampaignId: $adCampaignId, data: $data) {
            id
            name
            status
        }
    }
`

// technically these should go in helpers, or we should be using ZOD or something similar for validation
export const emptyInstantForm = {
    name: '',
    locale: 'en_US',
    privacy_policy_url: '',
    form_type: 'MORE_VOLUME', // or 'HIGHER_INTENT'
    follow_up_action_url: '',
    thank_you_page: {
        title: '',
        body: '',
        call_to_action: {
            type: 'VIEW_WEBSITE',
            value: {
                link: '',
                link_caption: '',
            },
        },
    },
    questions: [],
}

export const emptyCustomQuestion = {
    type: 'CUSTOM',
    label: '',
    key: '',
    options: [''],
}
